import { useContext } from 'react';
import { GameContext } from 'contexts/GameContext';
import BoardContainer from 'containers/Board';
import { Body, Row } from 'elements/Table';
import Cell from 'components/Cell';

const Board = () => {
  const { letters, positions, isComplete } = useContext(GameContext);

  return (
    <BoardContainer
      m="0 auto 1rem"
      width="100%"
      isComplete={isComplete}
      noSelect
    >
      <Body>
        {letters.map((row, i) => (
          <Row key={`row-${i}`}>
            {row.map((letter, j) => (
              <Cell key={`cell-${i}-${j}`} position={positions[i][j]}/>
            ))}
          </Row>
        ))}
      </Body>
    </BoardContainer>
  );
}

export default Board;
